module.exports = __webpack_public_path__ + "static/media/ca.eb26fcf6.webp";